import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import { Container, Row, Col, Card, CardBody, Button } from "reactstrap";

const copyByReason = (reason) => {
    switch (reason) {
        case "no_session":
            return {
                title: "Session expired",
                body: "Please sign in again.",
                primary: { text: "Go to login", to: "/login" },
                secondary: null,
            };
        case "missing":
            return {
                title: "We’re setting up your SAGE account",
                body: "Your login worked, but your SAGE profile is not ready yet. Please try again.",
                primary: { text: "Try again", to: "/home" },
                secondary: { text: "Go to login", to: "/login" },
            };
        case "error":
        default:
            return {
                title: "Could not load your account",
                body: "Please refresh and try again.",
                primary: { text: "Refresh", action: "reload" },
                secondary: { text: "Back to Login", to: "/login" },
            };
    }
};

const AccountIssue = () => {
    const history = useHistory();
    const location = useLocation();

    const reason = location?.state?.reason || "error";
    const detail = location?.state?.detail || "";
    const cfg = copyByReason(reason);

    const onPrimary = () => {
        if (cfg.primary.action === "reload") window.location.reload();
        else history.replace(cfg.primary.to);
    };

    const onSecondary = () => {
        if (!cfg.secondary) return;
        history.replace(cfg.secondary.to);
    };

    return (
        <div className="account-pages my-5 pt-sm-5">
            <Container>
                <Row className="justify-content-center">
                    <Col md={8} lg={6} xl={5}>
                        <Card className="overflow-hidden">
                            <CardBody className="pt-4">
                                <div className="p-2">
                                    <h4 className="mb-2">{cfg.title}</h4>
                                    <p className="text-muted mb-3">{cfg.body}</p>

                                    {detail ? (
                                        <p className="text-muted" style={{ fontSize: 12, opacity: 0.8 }}>
                                            {detail}
                                        </p>
                                    ) : null}

                                    <div className="d-flex gap-2 mt-3">
                                        <Button color="primary" onClick={onPrimary}>
                                            {cfg.primary.text}
                                        </Button>

                                        {cfg.secondary ? (
                                            <Button color="secondary" onClick={onSecondary}>
                                                {cfg.secondary.text}
                                            </Button>
                                        ) : null}
                                    </div>
                                </div>
                            </CardBody>
                        </Card>

                        <div className="mt-3 text-center text-muted" style={{ fontSize: 12 }}>
                            Permaculture Gardens · SAGE
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default AccountIssue;
